import React from 'react';
import ShopImageUploader from './ShopImageUploader';

interface CoverUploaderProps {
  shopId: string;
  coverImageUrl: string;
  placeholderUrl?: string;
  uploadUrl?: string;
  invalidateQueryKey?: import('@tanstack/react-query').QueryKey;
  onUploaded?: (url: string) => void;
}

const CoverUploader: React.FC<CoverUploaderProps> = ({
  shopId,
  coverImageUrl,
  placeholderUrl = 'https://placehold.co/800x200?text=Cover+Image',
  uploadUrl,
  invalidateQueryKey,
  onUploaded,
}) => {
  return (
    <ShopImageUploader
      shopId={shopId}
      imageType="cover"
      title="Cover Image"
      initialUrl={coverImageUrl}
      placeholderUrl={placeholderUrl}
      buttonLabel="Change Cover"
      containerStyle={{ width: '100%', height: 220, borderRadius: 16 }}
      imageStyle={{ borderRadius: 16 }}
      uploadUrl={uploadUrl}
      invalidateQueryKey={invalidateQueryKey}
      onUploaded={onUploaded}
    />
  );
};

export default CoverUploader;
